<template>
	<div></div>
</template>

<script>
import * as utils from '@/utils/utils';
export default {
	name: 'EventTracker',
	data: () => {
		return {
			utils: utils,
			intervaller: null,
			eid: '',
			cachedEvents: {}
		};
	},
	created() {
		this.trackEvents();
		window.emitter.$on('hidden', () => {
			this.stopTracker();
		});
		window.emitter.$on('windowVisible', () => {
			this.getEvents();
			this.getEventData();
		});
	},
	watch: {
		$route(to, from) {
			const name = to.name;
			if (name === 'Reservations' || name === 'Home') {
				window.emitter.$emit('newEvents', Object.values(this.cachedEvents));
			}
		}
	},
	destroyed() {
		this.stopTracker();
	},
	computed: {
		isLoggedIn() {
			return (
				this.$route.name.indexOf('Login') < 0 && this.$route.name != 'Logout'
			);
		}
	},
	methods: {
		trackEvents() {
			utils.getData(basePath + 'api/rentunits/setFlags').then(response => {
				this.eid = response.eid;
				this.getEvents();
			});
		},
		getEvents() {
			this.intervaller = setInterval(() => {
				this.getEventData();
			}, 10000);
		},
		getEventData() {
			if (this.isLoggedIn && this.eid) {
				utils
					.getData(basePath + 'api/rentunits/getEvents/' + this.eid)
					.then(response => {
						if (response.events) {
							window.emitter.$emit('newEvents', response.events);
							this.updateElements(response.events);
						} else {
							// If session invalid - reset flags
							this.stopTracker();
							this.trackEvents();
						}
					});
			}
		},
		stopTracker() {
			console.log('stop tracker');
			clearInterval(this.intervaller);
		},
		updateElements(events) {
			let self = this;
			for (let i = 0; i < events.length; i++) {
				const unit = events[i];
				if (unit.d.pos) {
					this.cachedEvents[unit.i] = unit;
					const el = document.getElementsByClassName('unit_' + String(unit.i));
					if (el && el.length) {
						const speed = unit.d.pos.s;
						for (let i = 0; i < el.length; i++) {
							if (speed > 0) {
								el[i].innerHTML = speed + ' km/u';
							} else {
								el[i].innerHTML = '';
							}
						}
					}
				}
			}
		}
	}
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/EventTracker/EventTracker.vue